export const getToken = () => localStorage.getItem('fm_token')
export const setToken = (t: string) => localStorage.setItem('fm_token', t)
export const clearToken = () => localStorage.removeItem('fm_token')
export const isLoggedIn = () => !!getToken()
